import { render, staticRenderFns } from "./SecondaryButton.vue?vue&type=template&id=44614924"
import script from "./SecondaryButton.vue?vue&type=script&lang=js"
export * from "./SecondaryButton.vue?vue&type=script&lang=js"
import style0 from "./SecondaryButton.vue?vue&type=style&index=0&id=44614924&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports